import { getEntityRef } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { withIsVisible } from "@client/hocs";
import React from "react";

export type MapProps = RootContainerProps & {
  horizontalAlign: "left" | "center" | "right" | "justify";
  textStyle: React.CSSProperties;
  title: string;
};

export type ActionProps = {};

export default withIsVisible((props: ActionProps & MapProps) => (
  <div style={{ textAlign: props.horizontalAlign }}>
    <props.TextComponent
      {...getEntityRef(props)}
      toolbar={"basic"}
      prop="disclaimer"
      style={props.textStyle}
      tag="p"
      html={props.title}
    />
  </div>
));
